module.exports = __webpack_public_path__ + "static/media/homepage_commerce-mobile.477ceb94.mp4";